// src/components/agenda/Task.js
import React from 'react';
import { renderMarkdown } from '../../services/utils';

const Task = ({ task, onUpdate, onDelete, level, isViewMode }) => {
  // Nimmt den Namen aus dem ersten Element des assignees-Arrays
  const assigneeName = task.assignees && task.assignees.length > 0 ? task.assignees[0].name : 'Niemand';

  return (
    <div className={`flex flex-col sm:flex-row items-start sm:items-center justify-between py-2 mb-2 border-l-4 ${
      level > 0 ? 'border-purple-400 dark:border-purple-600 bg-purple-50 dark:bg-gray-700' : 'border-blue-400 dark:border-blue-600 bg-blue-50 dark:bg-gray-700'
    } pl-3 rounded-lg`}>
      <div className="flex-grow">
        <p className="text-gray-800 dark:text-gray-200 font-semibold">
            {/* *** NEU: Task-Nummer anzeigen *** */}
            {task.sequentialNumber && (
                <span className="font-bold text-purple-600 dark:text-purple-400 mr-2">
                    [T-{task.sequentialNumber}]
                </span>
            )}
            {task.title}
        </p>
        
        {/* *** KORREKTUR START *** */}
        {isViewMode ? (
          <div
            className="text-sm text-gray-700 dark:text-gray-300 mt-1 prose dark:prose-invert"
            // KORRIGIERT: Muss ein Objekt { __html: "..." } sein
            // Fügt auch einen Fallback (|| '') hinzu, falls die Beschreibung leer ist
            dangerouslySetInnerHTML={{ __html: renderMarkdown(task.description || '') }}
          />
        ) : (
          <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">{task.description}</p>
        )}
        {/* *** KORREKTUR ENDE *** */}

        <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
          Zugewiesen an: <span className="font-medium">{assigneeName}</span> | Status: <span className="font-medium">{task.status}</span> | Fällig: <span className="font-medium">{task.dueDate || 'Kein Datum'}</span>
          {task.project && <span className="ml-2">| Projekt: <span className="font-medium">{task.project}</span></span>}
        </p>
      </div>
      {!isViewMode && (
        <div className="flex space-x-2 mt-3 sm:mt-0">
          <button
            onClick={() => onUpdate(task)}
            className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-all duration-200 ease-in-out transform hover:scale-105 text-sm font-medium shadow-sm"
          >
            Bearbeiten
          </button>
          <button
            onClick={() => onDelete(task.id)}
            className="w-8 h-8 flex items-center justify-center bg-red-500 text-white rounded-full hover:bg-red-600 transition-all duration-200 ease-in-out transform hover:scale-110 text-sm font-medium shadow-sm"
            title="Aufgabe löschen"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      )}
    </div>
  );
};

export default Task;

